import React from "react";
import ChooseCluster from "../functional-components/ChooseCluster/ChooseCluster.jsx";

const ChooseClusterPage = () => {
  return (
    <div>
      <ChooseCluster />
    </div>
  );
};

export default ChooseClusterPage;
